import React from "react";
import _1 from "../../assets/Images/1.png";
import _2 from "../../assets/Images/2.png";
import _3 from "../../assets/Images/3.png";
import _4 from "../../assets/Images/4.png";
import _5 from "../../assets/Images/5.png";

function Products() {
  return (
    <div className="relative min-h-screen h-[calc(100vh+300px)] py-16 overflow-hidden">
      <div className="absolute top-16 right-20 bg-[#333333] w-[348px] h-[688.552px] rotate-[49.43deg] rounded-[50%] blur-[150px]  mix-blend-plus-lighter flex-shrink-0" />

      <div className="max-w-6xl pl-20 mx-auto mt-10">
        <div className="w-full">
          <h1 className="text-[30px] font-semibold font-Gilroy text-transparent bg-clip-text bg-gradient-to-r from-[#EAEAEA] to-[#848484] mb-5 tracking-wide w-fit">
            Products
          </h1>

          <div className="flex items-center gap-7 text-nav">
            {[
              "All",
              "Cybersecurity",
              "Software Development",
              "App Design",
              "Web Design",
            ].map((item, index) => (
              <div
                key={index}
                className={`px-3 pb-2 ${
                  index === 0 ? "text-white border-b-[3px] border-white" : ""
                }`}
              >
                {item}
              </div>
            ))}
          </div>
          <div className="py-10 ">
            <div className="grid grid-cols-5 gap-10">
              <div className=" h-72 col-span-3 bg-gradient-to-br from-[#9986FF] via-[#73FF9A]/30 to-transparent rounded-3xl p-px group cursor-pointer">
                <div className="relative rounded-[calc(1.5rem-1px)] bg-black h-full p-1">
                  <div className="absolute inset-0 rounded-[calc(1.5rem-1px)] bg-[#D9D9D91A] flex items-center justify-center h-full" />

                  <div className="relative h-[calc(100%-70px)] w-full z-10">
                    <img
                      src={_1}
                      className="h-full w-full rounded-t-[calc(1.5rem-5px)] object-top object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                      alt="sandbox-ecommerce"
                    />
                  </div>

                  <div className="z-10 flex items-center px-10 py-5 text-sm">
                    <div className="h-2 w-2 rounded-full bg-[#2CA1BE] mr-2" />
                    <p>Sandbox Ecommerce</p>

                    <div className="py-1 px-4 text-nav text-white ml-5 rounded-full bg-[#292929] ">
                      Web
                    </div>
                  </div>
                </div>
              </div>

              <div className="relative h-72 col-span-2 bg-gradient-to-br from-[#1EFFAA] via-[#1EFFAA]/20 to-transparent overflow-hidden rounded-3xl p-px group cursor-pointer">
                <div className="relative rounded-[calc(1.5rem-1px)] bg-black h-full p-1">
                  <div className="absolute -top-44 -right-48 bg-[#333333]/50 w-[348px] h-[688.552px] rotate-[49.43deg] rounded-[50%] blur-[150px]" />
                  <div className="absolute inset-0 rounded-[calc(1.5rem-1px)] bg-[#D9D9D91A] flex items-center justify-center h-full" />

                  <div className="relative h-[calc(100%-70px)] w-full z-10">
                    <img
                      src={_2}
                      className="h-full w-full rounded-t-[calc(1.5rem-5px)] object-center object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                      alt="sandbox-ecommerce"
                    />
                  </div>

                  <div className="z-10 flex items-center px-8 py-5 text-sm">
                    <div className="h-2 w-2 rounded-full bg-[#9747FF] mr-2" />
                    <p>Jaxson System</p>

                    <div className="py-1 px-4 text-nav text-white ml-5 rounded-full bg-[#292929] ">
                      Security
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="relative grid grid-cols-7 gap-10 mt-10">
              <div className="absolute -top-1/4 right-1/4  w-[100px] h-[200px] rotate-[38deg] bg-[#2CA1BE] rounded-full z-10 blur-[128.2px] mix-blend-plus-lighter flex-shrink-0" />
              <div className="absolute -bottom-1/4 left-1/3 - w-[100px] h-[200px] rotate-[38deg] bg-[#C69100] rounded-full z-10 blur-[128.2px] mix-blend-plus-lighter flex-shrink-0" />
              <div className="h-72 col-span-3 bg-[#D9D9D91A] rounded-3xl p-1 group cursor-pointer">
                <div className="relative h-[calc(100%-70px)] w-full z-10">
                  <img
                    src={_3}
                    className="h-full w-full rounded-t-[calc(1.5rem-5px)] object-top object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                    alt="sandbox-ecommerce"
                  />
                </div>

                <div className="z-10 flex items-center px-10 py-5 text-nav">
                  <div className="h-2 w-2 rounded-full bg-[#2CA1BE] mr-2" />
                  <p className="line-clamp-1">Sandbox Ecommerce</p>

                  <div className="py-1 px-4 text-nav text-white ml-5 rounded-full bg-[#292929] ">
                    Web
                  </div>
                </div>
              </div>

              <div className="h-72 col-span-2 bg-[#D9D9D91A] rounded-3xl p-1 group cursor-pointer">
                <div className="relative h-[calc(100%-70px)] w-full z-10">
                  <img
                    src={_4}
                    className="h-full w-full rounded-t-[calc(1.5rem-5px)] object-top object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                    alt="sandbox-ecommerce"
                  />
                </div>

                <div className="z-10 flex items-center px-10 py-5 text-nav">
                  <div className="h-2 w-2 rounded-full bg-[#2CA1BE] mr-2" />
                  <p className="line-clamp-1">Resturant Mobile app</p>

                  <div className="py-1 px-4 text-nav text-white ml-5 rounded-full bg-[#292929] ">
                    Web
                  </div>
                </div>
              </div>

              <div className="h-72 col-span-2 bg-[#D9D9D91A] rounded-3xl p-1 group cursor-pointer">
                <div className="relative h-[calc(100%-70px)] w-full z-10">
                  <img
                    src={_5}
                    className="h-full w-full rounded-t-[calc(1.5rem-5px)] object-top object-cover grayscale group-hover:grayscale-0 transition-all duration-300"
                    alt="sandbox-ecommerce"
                  />
                </div>

                <div className="z-10 flex items-center px-10 py-5 text-nav">
                  <div className="h-2 w-2 rounded-full bg-[#2CA1BE] mr-2" />
                  <p className="line-clamp-1">Sandbox Ecommerce</p>

                  <div className="py-1 px-4 text-nav text-white ml-5 rounded-full bg-[#292929] ">
                    Web
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center pb-10 my-6 text-nav">
        <div className="flex items-center p-px cursor-pointer bg-gradient-to-r from-[#717171] to-[#505050] rounded-3xl">
          <div className="text-gray-200 bg-black rounded-[calc(1.5rem-1px)] px-6 py-3">
            See more
          </div>
        </div>
      </div>
    </div>
  );
}

export default Products;
